import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { EASE } from '../../lib/motion';

// Transition entre deux pages : l'ancienne s'efface (0,18 s), la page défile en haut, la nouvelle
// apparaît (0,28 s). `children` est une fonction qui reçoit la location à rendre : l'élément
// sortant garde ainsi SA location pendant qu'il s'efface (sinon il afficherait déjà la nouvelle page).
// Pas d'animation au tout premier affichage (pré-rendu intact).
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false} onExitComplete={() => window.scrollTo(0, 0)}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0, transition: { duration: 0.28, ease: EASE } }}
        exit={{ opacity: 0, y: -6, transition: { duration: 0.18, ease: 'easeIn' } }}
      >
        {children(location)}
      </motion.div>
    </AnimatePresence>
  );
}
